import React, { FC, useMemo } from "react";
import { User, AppWindowMac, BatteryWarning } from "lucide-react";
import { meters_to_km_velocity } from "@/utils/variables";
import { Fuels } from "@/interface/dataInterface";

interface Props {
  data: any;
  fuelTypes: Fuels[];
}

const TaxiStatus: FC<Props> = ({ data, fuelTypes }) => {
  const variables = React.useMemo(() => {
    const vars: Record<string, any> = {};

    data?.variables.forEach((variable: any) => {
      if (variable?.name) {
        vars[variable.name] = variable?.value || "False";
      }
    });

    return vars;
  }, [data]);

  const batteryLevel = useMemo(
    () =>
      Number(variables["Bateria_makines_elektrike"]) ||
      Number(variables["BatteryLevel"]) ||
      null,
    [variables  ],
  );

  return (
    <div className="flex items-center space-x-2">
      {variables["Ignition"] === "True" &&
      Math.round(data?.velocity.groundSpeed * meters_to_km_velocity) === 0 ? (
        <div className="w-4 h-4 rounded-full flex items-center justify-center text-white font-bold bg-green-500">
          <p className="text-[9px] text-yellow-200">N</p>
        </div>
      ) : variables["Ignition"] === "True" ? (
        <div className="w-4 h-4 rounded-full bg-green-500 flex items-center justify-center text-white font-bold">
          <p className="text-[9px]">D</p>
        </div>
      ) : (
        <div className="w-4 h-4 rounded-full bg-gray-400 flex items-center justify-center text-white font-bold">
          <p className="text-[9px]">P</p>
        </div>
      )}
      {(variables["Pasagjer"] ||
        variables["SeatSensor"] ||
        variables["Prezenca"]) && (
        <User
          className="w-4 h-4"
          style={{
            color:
              (variables["Ignition"] == "True" &&
                (variables["SeatSensor"] == "True" ||
                  variables["Pasagjer"] == "True")) ||
              variables["Prezenca"] == "True"
                ? "#ff4d4d"
                : "#00ff00",
          }}
        />
      )}
      {(variables["Taximeter"] || variables["TaxiMeter"]) && (
        <AppWindowMac
          className="w-4 h-4"
          style={{
            color:
              variables["Ignition"] == "True" &&
              (variables["Taximeter"] == "True" ||
                variables["TaxiMeter"] == "True")
                ? "#ff4d4d"
                : "#00ff00",
          }}
        />
      )}
      {((fuelTypes?.length > 0 &&
        fuelTypes[0] &&
        fuelTypes[0]?.fuel.name === "Electric") ||
        (fuelTypes?.length > 0 &&
          fuelTypes[1] &&
          fuelTypes[1]?.fuel.name === "Electric")) &&
          (batteryLevel ? (
            <p className="text-[12px] font-bold">
              {batteryLevel < 1 ? Math.round(batteryLevel * 100) : batteryLevel}{" "}
              %
            </p>
          ) : (
            <BatteryWarning />
          ))}
    </div>
  );
};

export default TaxiStatus;
